import { gql } from '../../__generated__'

export const GET_USER_NOTIFICATION_SETTINGS = gql(/* GraphQL */ `
  query GetUserNotificationSettings {
    users {
      id
      notificationNewReleasesFromPublishers
      notificationNewReleasesFromPublishersList
      notificationNewReleasesFromAuthors
      notificationNewReleasesFromAuthorsList
      notificationAddedReleaseDateToExistingReleaseCollectionItem
      notificationChangedReleaseDateOfExistingReleaseCollectionItem
      notificationReleaseCollectionItemAvailable
      notificationReleaseCollectionItemAlternativeVersionRelease
      notificationScannedItemAvailable
      notificationAtsumeRecommendations
    }
  }
`)

export const UPDATE_USER_NOTIFICATION_SETTINGS = gql(/* GraphQL */ `
  mutation UpdateUserNotificationSettings(
    $where: UserWhereUniqueInput!
    $data: UserUpdateInput!
  ) {
    updateUser(where: $where, data: $data) {
      id
      notificationNewReleasesFromPublishers
      notificationNewReleasesFromPublishersList
      notificationNewReleasesFromAuthors
      notificationNewReleasesFromAuthorsList
      notificationAddedReleaseDateToExistingReleaseCollectionItem
      notificationChangedReleaseDateOfExistingReleaseCollectionItem
      notificationReleaseCollectionItemAvailable
      notificationReleaseCollectionItemAlternativeVersionRelease
      notificationScannedItemAvailable
      notificationAtsumeRecommendations
    }
  }
`)

export const SEARCH_PUBLISHERS = gql(/* GraphQL */ `
  query SearchPublishers($where: PublisherWhereInput!, $take: Int) {
    publishers(where: $where, orderBy: [{ name: asc }], take: $take) {
      id
      name
    }
  }
`)

export const GET_PUBLISHERS_BY_IDS = gql(/* GraphQL */ `
  query GetPublishersByIds($where: PublisherWhereInput!) {
    publishers(where: $where, orderBy: [{ name: asc }]) {
      id
      name
    }
  }
`)

export const SEARCH_INDIVIDUALS = gql(/* GraphQL */ `
  query SearchIndividuals($where: IndividualWhereInput!, $take: Int) {
    individuals(where: $where, orderBy: [{ lastName: asc }], take: $take) {
      id
      name
    }
  }
`)

export const GET_INDIVIDUALS_BY_IDS = gql(/* GraphQL */ `
  query GetIndividualsByIds($where: IndividualWhereInput!) {
    individuals(where: $where, orderBy: [{ lastName: asc }]) {
      id
      name
    }
  }
`)
